import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        for (const tab of this.element.querySelectorAll('.tab')) {
            tab.addEventListener('click', () => this.toggleTab(tab));
        }
    }

    toggleTab(tab) {
        if (!tab.getAttribute('data-tab')) {
            return;
        }

        const parent = tab.parentNode.parentNode;
        for (const tabInner of parent.querySelectorAll('.tab')) {
            tabInner.classList.remove('active');
        }

        for (const tabContent of parent.querySelectorAll('.tab-content')) {
            tabContent.classList.remove('active');
        }

        const content = parent.querySelector(`.${tab.getAttribute('data-tab')}`);
        tab.classList.add('active');
        content.classList.add('active');
    }
}
